import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export default function HeroCarousel() {
  const [SLIDES, setSlides] = useState(null);
  const [i, setI] = useState(0);

  useEffect(() => {
    api.get("/slides").then(({ data }) => setSlides(data)).catch(() => setSlides([]));
  }, []);

  useEffect(() => {
    if (!SLIDES || SLIDES.length < 2) return undefined;
    const t = setInterval(() => setI((p) => (p + 1) % SLIDES.length), 4500);
    return () => clearInterval(t);
  }, [SLIDES]);

  if (SLIDES && SLIDES.length === 0) return null;
  if (!SLIDES) return <section className="relative h-[60vh] md:h-[70vh] bg-[#1C1917]" data-testid="hero-carousel" />;

  return (
    <section className="relative h-[60vh] md:h-[70vh] overflow-hidden" data-testid="hero-carousel">
      {SLIDES.map((s, idx) => (
        <div
          key={s.id}
          className="absolute inset-0 transition-opacity duration-700"
          style={{ opacity: idx === i ? 1 : 0 }}
        >
          <img src={imgUrl(s.image)} alt={s.title || "Paulista's"} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/45" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-6xl mx-auto px-5 w-full">
              <div className="max-w-xl">
                <p className="uppercase tracking-[0.25em] text-secondary text-xs font-bold mb-3">
                  {s.eyebrow}
                </p>
                <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-white leading-none tracking-tight">
                  {s.title}
                </h1>
                <p className="text-white/85 text-base md:text-lg mt-4 leading-relaxed">
                  {s.sub}
                </p>
                <a
                  href="#cardapio"
                  data-testid="hero-cta"
                  className="inline-flex mt-7 rounded-full bg-primary text-primary-foreground px-7 py-3 font-semibold hover:bg-primary/90 transition-colors"
                >
                  Ver o cardápio
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {SLIDES.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setI(idx)}
            data-testid={`hero-dot-${idx}`}
            className="h-2 rounded-full transition-all"
            style={{
              width: idx === i ? 28 : 8,
              background: idx === i ? "#E53935" : "rgba(255,255,255,.6)",
            }}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
